import { Formatter } from './Formatter.js';
import { StringCompare } from './StringCompare.js';
export class DataValidator {
    static UITPAS_NUMBER_REGEX = /^\d{10,13}$/;
    static isEmailValid(str) {
        const blockList = [
            'gmail.be',
            'gmail.nl',
            'icloud.be',
        ];
        const regex = /^[\w.!#$%&*+/=?^`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i;
        if (!regex.test(str)) {
            return false;
        }
        for (const l of blockList) {
            if (str.endsWith('@' + l)) {
                return false;
            }
        }
        const domain = str.split('@')[1];
        if (domain.length > 255) {
            return false;
        }
        const typo = ['gmail.com', 'hotmail.com', 'hotmail.fr', 'hotmail.be', 'yahoo.com', 'live.com', 'outlook.com', 'icloud.com', 'skynet.be', 'telenet.be', 'proximus.be', 'scarlet.be', 'vodafone.be', 'orange.be'];
        let foundInvalid = false;
        for (const t of typo) {
            if (domain === t) {
                return true;
            }
            if (StringCompare.typoCount(domain, t) === 1) {
                foundInvalid = true;
            }
        }
        if (domain === 'mail.com') {
            // Exception for typo on gmail.com
            return true;
        }
        if (foundInvalid) {
            return false;
        }
        const tld = domain.split('.').pop();
        if (!tld || tld.length < 2) {
            return false;
        }
        return true;
    }
    static isUitpasNumberValid(str) {
        return this.UITPAS_NUMBER_REGEX.test(str);
    }
    static isUuid(value) {
        if (typeof value !== 'string') {
            return false;
        }
        return value.length === 36 && value[8] === '-' && value[13] === '-' && value[18] === '-' && value[23] === '-';
    }
    static isUitpasNumberKansenTarief(str) {
        const isValid = this.isUitpasNumberValid(str);
        if (!isValid) {
            return false;
        }
        const char = str[str.length - 2];
        return char === '1';
    }
    static formatUitpasNumber(text) {
        const trimmed = this.cleanUitpasNumber(text);
        // XXXX XXX XXX XXX
        return Formatter.injectPattern(trimmed, [
            { length: 4 },
            ' ',
            { length: 3 },
            ' ',
            { length: 3 },
            ' ',
            { length: 3 },
        ]);
    }
    static verifyBelgianNationalNumber(text) {
        const trimmed = text.replace(/\D+/g, ''); // keep A-Z for validation
        if (trimmed.length !== 11) {
            return false;
        }
        const toCheck = parseInt(trimmed.substring(0, trimmed.length - 2));
        const checksum = parseInt(trimmed.substring(trimmed.length - 2));
        // we calculate the expected checksum. again
        const realChecksum = 97 - (toCheck % 97); // Dates before 2000
        const realChecksum2 = 97 - ((2000000000 + toCheck) % 97); // Dates after 2000
        if (STAMHOOFD.environment === 'development') {
            return true;
        }
        if (checksum === realChecksum || checksum === realChecksum2) {
            // Check birth day via doesMatchBelgianNationalNumber
            return true;
        }
        return false;
    }
    static doesMatchBelgianNationalNumber(text, birthDay) {
        if (!birthDay) {
            return true;
        }
        // Check if year, month and day matches
        const generated = this.generateBelgianNationalNumber(birthDay);
        if (this.formatBelgianNationalNumber(text).startsWith(generated)) {
            return true;
        }
        return false;
    }
    static cleanBelgianNationalNumber(text) {
        return text.replace(/\D+/g, '');
    }
    static cleanPhone(text) {
        return text.replace(/[^+0-9]+/g, '');
    }
    static cleanUitpasNumber(text) {
        return text.replace(/\D+/g, '');
    }
    static getUitpasNumberInputFormatter() {
        return {
            cleaner: (value) => {
                return this.cleanUitpasNumber(value);
            },
            formatter: (value) => {
                return this.formatUitpasNumber(value);
            },
        };
    }
    static getBelgianNationalNumberInputFormatter() {
        return {
            cleaner: (value) => {
                return this.cleanBelgianNationalNumber(value);
            },
            formatter: (value) => {
                return this.formatBelgianNationalNumber(value);
            },
        };
    }
    static formatBelgianNationalNumber(text) {
        const trimmed = this.cleanBelgianNationalNumber(text);
        // JJ.MM.DD-XXX.XX
        return Formatter.injectPattern(trimmed, [
            { length: 2 },
            '.',
            { length: 2 },
            '.',
            { length: 2 },
            '-',
            { length: 3 },
            '.',
            { length: 2 },
        ]);
    }
    static generateBelgianNationalNumber(date) {
        // JJ.MM.DD-
        const year = Formatter.year(date).toFixed();
        const month = Formatter.monthNumber(date).toFixed();
        const day = Formatter.day(date);
        return year.substring(2) + '.' + month.padStart(2, '0') + '.' + day.padStart(2, '0') + '-';
    }
}
//# sourceMappingURL=DataValidator.js.map